import { Button, Input } from 'antd';
import React, { Component, Fragment } from 'react';
import store from '../../../redux/store';
import { roll } from '../../../untils/auth';

export default class BlogNav extends Component {
  state = {
    searchBoxShow: false, //搜索框是否展示
    searchValue: '', //搜索框关键词
  };

  //搜索框是否展示
  openSearchHandle = () => {
    this.setState({
      searchBoxShow: !this.state.searchBoxShow,
    });
    if (this.state.searchBoxShow) {
      store.dispatch({
        type: 'clear_keyword',
      });
    }
  };

  //click tag
  changeNavHandle = (item) => {
    this.props.changeUrlHandle(item);
  };

  // 获取search
  getSearchValueHandle = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  //点击搜索
  searchBlogClickHandle = () => {
    let { searchValue, searchBoxShow } = this.state;
    let bannerHeight = 0;
    if (document.querySelector('.banner')) {
      bannerHeight = document.querySelector('.banner').offsetHeight;
    }
    roll(bannerHeight);
    if (searchValue) {
      if (this.props.history.location.pathname === `/blog`) {
        let page = 1;
        this.props.searchBlogList(searchValue, page);
      } else {
        this.saveValueHandle(searchValue, searchBoxShow);
      }
    }
  };

  //回车搜索
  searchBlogEnterHandle = (e) => {
    let { searchValue, searchBoxShow } = this.state;
    if (searchValue && searchBoxShow && e.keyCode === 13) {
      let bannerHeight = 0;
      if (document.querySelector('.banner')) {
        bannerHeight = document.querySelector('.banner').offsetHeight;
      }
      roll(bannerHeight);

      if (this.props.history.location.pathname === `/blog`) {
        let page = 1;
        let myInput = document.getElementById('searchInput');
        if (myInput === document.activeElement) {
          myInput.blur();
        }
        this.props.searchBlogList(searchValue, page);
      } else {
        this.saveValueHandle(searchValue, searchBoxShow);
      }
    }
  };

  //储存keyword并跳转到all分类
  saveValueHandle = (data) => {
    store.dispatch({
      type: 'save_keyword',
      data,
    });
    this.props.history.push({
      pathname: `/blog`,
    });
  };

  //滚动到一定距离隐藏搜索框
  searchBoxHandleScroll = (e) => {
    const scrollTop =
      (e.srcElement ? e.srcElement.documentElement.scrollTop : false) ||
      window.pageYOffset ||
      (e.srcElement ? e.srcElement.body.scrollTop : 0);

    let dom = document.querySelector('.blog-category-list');
    if (dom) {
      if (
        scrollTop > dom.offsetTop + 400 &&
        (!this.state.searchValue || !this.props.isSearchShow)
      ) {
        this.setState({
          searchBoxShow: false,
          searchValue: '',
        });
      }
    }
  };

  componentDidMount() {
    let keyword = store.getState().getBlogSearchkeyword;
    if (keyword) {
      this.setState({
        searchValue: keyword,
        searchBoxShow: true,
      });
    }
    window.addEventListener('scroll', this.searchBoxHandleScroll);
  }

  // 卸载
  componentWillUnmount() {
    window.removeEventListener('scroll', this.searchBoxHandleScroll);
  }

  render() {
    let { searchBoxShow, searchValue } = this.state;
    let { tagsArr, moreArr } = this.props.categoryTagsData;

    // Get the current category from URL query
    const searchParams = new URLSearchParams(this.props.location.search);
    const currentCategory = searchParams.get('category') || '';

    return (
      <Fragment>
        <div className="blog-menu">
          <ul className="blog-category-nav">
            <li className={`default ${!currentCategory ? 'active' : ''}`}>
              <button
                className="nav-button"
                onClick={() => {
                  this.changeNavHandle();
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') this.changeNavHandle();
                }}
                aria-label="All Posts"
              >
                <span>All Posts</span>
              </button>
            </li>
            {tagsArr &&
              tagsArr.map((item) => {
                return (
                  <li
                    className={`${currentCategory === item.url ? 'active' : ''}`}
                    key={item.id}
                    onClick={() => {
                      this.changeNavHandle(item);
                    }}
                  >
                    <span>{item.name}</span>
                  </li>
                );
              })}
            {moreArr && moreArr.length ? (
              <li className="more">
                <span>More</span>
                <ul className="nav-list">
                  {moreArr.map((item) => {
                    return (
                      <li
                        className={`${currentCategory === item.url ? 'active' : ''}`}
                        key={item.id}
                        onClick={() => {
                          this.changeNavHandle(item);
                        }}
                      >
                        <span>{item.name}</span>
                      </li>
                    );
                  })}
                </ul>
              </li>
            ) : null}
          </ul>
          {this.props.option === 'search' && (
            <button
              className="search"
              onClick={() => {
                this.openSearchHandle();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') this.openSearchHandle();
              }}
              aria-label="Search"
            >
              <img
                src={require('../../../assets/imgs/svg/blog-seach-nav.svg').default}
                alt="search icon"
              />
            </button>
          )}
        </div>

        {this.props.option === 'search' && searchBoxShow && (
          <div className="search-box">
            <div>
              <Input
                placeholder="Please enter a keyword"
                id="searchInput"
                onChange={(e) => {
                  this.getSearchValueHandle(e);
                }}
                onKeyDown={(e) => {
                  this.searchBlogEnterHandle(e);
                }}
                value={searchValue}
              />
              <button
                className="search-btn"
                onClick={() => {
                  this.searchBlogClickHandle();
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') this.searchBlogClickHandle();
                }}
                aria-label="Search"
              >
                <Button type="primary" className="seach bg-image"></Button>
                <img
                  src={require('../../../assets/imgs/svg/blog-seach-btn.svg').default}
                  alt="search icon"
                />
              </button>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
